var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from 'react';
var SPolylineAbstract = /** @class */ (function (_super) {
    __extends(SPolylineAbstract, _super);
    function SPolylineAbstract(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SPolylineAbstract.defaultProps = {
        _type_map: "polyline",
        coordinates: [],
        strokeColor: "#000000",
        strokeWidth: 1
    };
    return SPolylineAbstract;
}(Component));
export default SPolylineAbstract;
